import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Field, Input } from '@dossierhq/design';
import {} from '../../reducers/SchemaEditorReducer/SchemaEditorReducer.js';
export function SchemaPatternEditor({ patternDraft, onEditPattern }) {
    return (_jsxs(Field, { children: [_jsx(Field.Label, { children: "Pattern" }), _jsx(Field.Control, { children: _jsx(Input, { readOnly: true, value: patternDraft.pattern, textStyle: "code1", onClick: onEditPattern }) })] }));
}
//# sourceMappingURL=SchemaPatternEditor.js.map